import React from 'react';
import s from './TopBar.module.css';

const TopBar = () => {
  return (
    <div className={s.topBarWrapper}>
      <div className={s.topBarLeft}>
        <i className={`g72-swoosh ${s.icon}`} />
        <div className="header-underline">
          <h4>PARC APPLICATION PORTAL</h4>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
